// extracted by mini-css-extract-plugin
export default {"xcontainer":"MarksEntryPage_xcontainer__B79zJ","marksentrypage":"MarksEntryPage_marksentrypage__yTypS"};